import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useCallback,
  useRef,
} from "react";
import { MdSmartToy } from "react-icons/md";
import typebotIcon from "../../assets/typebot-ico.png";
import { HiOutlinePuzzle } from "react-icons/hi";

import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";

import audioNode from "./nodes/audioNode";
import typebotNode from "./nodes/typebotNode";
import openaiNode from "./nodes/openaiNode";
import directOpenaiNode from "./nodes/directOpenaiNode";
import messageNode from "./nodes/messageNode.js";
import RemoveEdge from "./nodes/removeEdge";
import startNode from "./nodes/startNode";
import menuNode from "./nodes/menuNode";
import intervalNode from "./nodes/intervalNode";
import imgNode from "./nodes/imgNode";
import randomizerNode from "./nodes/randomizerNode";
import videoNode from "./nodes/videoNode";
import questionNode from "./nodes/questionNode";
import fileNode from "./nodes/fileNode";
import transferFlowNode from "./nodes/transferFlowNode";
import apiRequestNode from "./nodes/apiRequestNode";
import addTagNode from "./nodes/addTagNode";
import addTagKanbanNode from "./nodes/addTagKanbanNode";
import removeTagNode from "./nodes/removeTagNode";
import removeTagKanbanNode from "./nodes/removeTagKanbanNode";
import conditionNode from "./nodes/conditionNode";
import keywordConditionNode from "./nodes/keywordConditionNode";
import waitResponseNode from "./nodes/waitResponseNode";
import templateMsgNode from "./nodes/templateMsgNode";
import smartIntervalNode from "./nodes/smartIntervalNode";
import metaPixelNode from "./nodes/metaPixelNode";
import pixNode from "./nodes/pixNode";
import igActionNode from "./nodes/igActionNode";
import igFollowCheckNode from "./nodes/igFollowCheckNode";
import payLinkNode from "./nodes/payLinkNode";
import notifyNode from "./nodes/notifyNode";
import aiBlockNode from "./nodes/aiBlockNode";
import FlowBuilderAiBlockModal from "../../components/FlowBuilderAiBlockModal";
import FlowBuilderNotifyModal from "../../components/FlowBuilderNotifyModal";
import FlowBuilderMetaPixelModal from "../../components/FlowBuilderMetaPixelModal";
import FlowBuilderPixModal from "../../components/FlowBuilderPixModal";
import FlowBuilderIgActionModal from "../../components/FlowBuilderIgActionModal";
import FlowBuilderPayLinkModal from "../../components/FlowBuilderPayLinkModal";
import FlowBuilderSmartIntervalModal from "../../components/FlowBuilderSmartIntervalModal";
import FlowBuilderTemplateModal from "../../components/FlowBuilderTemplateModal";
import FlowBuilderWaitResponseModal from "../../components/FlowBuilderWaitResponseModal";
import asaasNode from "./nodes/asaasNode";
import smtpNode from "./nodes/smtpNode";
import googleSheetsNode from "./nodes/googleSheetsNode";
import variableNode from "./nodes/variableNode";
import closeTicketNode from "./nodes/closeTicketNode";
import sendMessageNode from "./nodes/sendMessageNode";
import waitQuestionNode from "./nodes/waitQuestionNode";
import scheduleAppointmentNode from "./nodes/scheduleAppointmentNode";
import listSchedulesNode from "./nodes/listSchedulesNode";
import checkAvailabilityNode from "./nodes/checkAvailabilityNode";
import updateAppointmentNode from "./nodes/updateAppointmentNode";
import cancelAppointmentNode from "./nodes/cancelAppointmentNode";
import fetchLastAppointmentNode from "./nodes/fetchLastAppointmentNode";
import smartAppointmentNode from "./nodes/smartAppointmentNode";
import sgpConsultaClienteNode from "./nodes/sgpConsultaClienteNode";
import sgpSegundaViaNode from "./nodes/sgpSegundaViaNode";
import sgpAbrirChamadoNode from "./nodes/sgpAbrirChamadoNode";
import sgpDesbloqueioNode from "./nodes/sgpDesbloqueioNode";
import sgpDiagnosticoNode from "./nodes/sgpDiagnosticoNode";
import scMenuPacienteNode from "./nodes/scMenuPacienteNode";
import scAgendamentosNode from "./nodes/scAgendamentosNode";
import scTreinosNode from "./nodes/scTreinosNode";
import scFaturasNode from "./nodes/scFaturasNode";
import infinityPayNode from "./nodes/infinityPayNode";

import api from "../../services/api";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { usePlanPermissions } from "../../context/PlanPermissionsContext";
import { Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Box, CircularProgress } from "@material-ui/core";
import BallotIcon from "@mui/icons-material/Ballot";

import "reactflow/dist/style.css";

import ReactFlow, {
  MiniMap,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  onElementsRemove,
  useReactFlow,
  Controls,
} from "react-flow-renderer";
import FlowBuilderAddTextModal from "../../components/FlowBuilderAddTextModal";
import FlowBuilderIntervalModal from "../../components/FlowBuilderIntervalModal";
import FlowBuilderConditionModal from "../../components/FlowBuilderConditionModal";
import FlowBuilderKeywordConditionModal from "../../components/FlowBuilderKeywordConditionModal";
import FlowBuilderMenuModal from "../../components/FlowBuilderMenuModal";
import {
  AccessTime,
  CallSplit,
  DynamicFeed,
  Image,
  ImportExport,
  LibraryBooks,
  Message,
  MicNone,
  PlayArrow,
  Videocam,
  Search,
  AccountTree,
  Http,
  LocalOffer,
  ViewKanban,
  Receipt,
  Email,
  Code,
  CheckCircle,
  Send,
  Schedule,
  Help,
  Rule,
  Event as EventIcon,
  RocketLaunch,
  DataObject,
  ShoppingBag,
  Edit as EditIcon,
  Cancel as CancelIcon,
  List as ListIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import FlowBuilderAddImgModal from "../../components/FlowBuilderAddImgModal";
import FlowBuilderTicketModal from "../../components/FlowBuilderAddTicketModal";
import FlowBuilderAddAudioModal from "../../components/FlowBuilderAddAudioModal";
import FlowBuilderAddFileModal from "../../components/FlowBuilderAddFileModal";

import { useNodeStorage } from "../../stores/useNodeStorage";
import FlowBuilderRandomizerModal from "../../components/FlowBuilderRandomizerModal";
import FlowBuilderAddVideoModal from "../../components/FlowBuilderAddVideoModal";
import FlowBuilderSingleBlockModal from "../../components/FlowBuilderSingleBlockModal";
import singleBlockNode from "./nodes/singleBlockNode";
import { colorPrimary } from "../../styles/styles";
import ticketNode from "./nodes/ticketNode";
import { ConfirmationNumber } from "@material-ui/icons";
import FlowBuilderTypebotModal from "../../components/FlowBuilderAddTypebotModal";
import FlowBuilderOpenAIModal from "../../components/FlowBuilderAddOpenAIModal";
import FlowBuilderAddDirectOpenAIModal from "../../components/FlowBuilderAddDirectOpenAIModal";
import { TOOL_CATALOG, DEFAULT_SENSITIVE_TOOLS } from "../../constants/aiTools.js";
import FlowBuilderAddQuestionModal from "../../components/FlowBuilderAddQuestionModal";
import FlowBuilderTransferFlowModal from "../../components/FlowBuilderTransferFlowModal";
import FlowBuilderApiRequestModal from "../../components/FlowBuilderApiRequestModal";
import FlowBuilderAddTagModal from "../../components/FlowBuilderAddTagModal";
import FlowBuilderAddTagKanbanModal from "../../components/FlowBuilderAddTagKanbanModal";
import FlowBuilderRemoveTagModal from "../../components/FlowBuilderRemoveTagModal";
import FlowBuilderRemoveTagKanbanModal from "../../components/FlowBuilderRemoveTagKanbanModal";
import FlowBuilderAsaasModal from "../../components/FlowBuilderAsaasModal";
import FlowBuilderAddSmtpModal from "../../components/FlowBuilderAddSmtpModal";
import FlowBuilderGoogleSheetsModal from "../../components/FlowBuilderGoogleSheetsModal";
import FlowBuilderAddVariableModal from "../../components/FlowBuilderAddVariableModal";
import FlowBuilderCloseTicketModal from "../../components/FlowBuilderCloseTicketModal";
import FlowBuilderSendMessageModal from "../../components/FlowBuilderSendMessageModal";
import FlowBuilderWaitQuestionModal from "../../components/FlowBuilderWaitQuestionModal";
import FlowBuilderProductListModal from "../../components/FlowBuilderProductListModal";
import FlowBuilderScheduleAppointmentModal from "../../components/FlowBuilderScheduleAppointmentModal";
import FlowBuilderListSchedulesModal from "../../components/FlowBuilderListSchedulesModal";
import FlowBuilderCheckAvailabilityModal from "../../components/FlowBuilderCheckAvailabilityModal";
import FlowBuilderUpdateAppointmentModal from "../../components/FlowBuilderUpdateAppointmentModal";
import FlowBuilderCancelAppointmentModal from "../../components/FlowBuilderCancelAppointmentModal";
import FlowBuilderFetchLastAppointmentModal from "../../components/FlowBuilderFetchLastAppointmentModal";
import FlowBuilderSmartAppointmentModal from "../../components/FlowBuilderSmartAppointmentModal";
import productListNode from "./nodes/productListNode";
import withNodeTitle from "../../components/FlowBuilderNodeWrapper";
import FlowBuilderNodeRenameModal from "../../components/FlowBuilderNodeRenameModal";
import FlowBuilderSgpConsultaModal from "../../components/FlowBuilderSgpConsultaModal";
import FlowBuilderScMenuPacienteModal from "../../components/FlowBuilderScMenuPacienteModal";
import FlowBuilderScAgendamentosModal from "../../components/FlowBuilderScAgendamentosModal";
import FlowBuilderScTreinosModal from "../../components/FlowBuilderScTreinosModal";
import FlowBuilderScFaturasModal from "../../components/FlowBuilderScFaturasModal";
import FlowBuilderSgpSegundaViaModal from "../../components/FlowBuilderSgpSegundaViaModal";
import FlowBuilderSgpChamadoModal from "../../components/FlowBuilderSgpChamadoModal";
import FlowBuilderSgpDesbloqueioModal from "../../components/FlowBuilderSgpDesbloqueioModal";
import FlowBuilderSgpDiagnosticoModal from "../../components/FlowBuilderSgpDiagnosticoModal";
import FlowBuilderInfinityPayModal from "../../components/FlowBuilderInfinityPayModal";
import SaveIcon from "@mui/icons-material/Save";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ChatIcon from "@material-ui/icons/Chat";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: 0,
    position: "relative",
    backgroundColor: "#fafbfc",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    border: "none",
    borderRadius: "12px",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
  },
  sidebar: {
    // menuAjustado2026: mais largura para os nomes nao cortarem
    width: "276px",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    zIndex: 1111,
    padding: "14px 14px 90px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    background: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(6px)",
    borderRight: "1px solid rgba(148, 163, 184, 0.25)",
    boxShadow: "12px 0 35px rgba(15, 23, 42, 0.08)",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    overflowY: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  lockIcon: {
    padding: "8px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },
  buttonGroup: {
    width: "100%",
    marginBottom: "10px",
    padding: "8px 6px",
    borderRadius: 14,
    backgroundColor: "rgba(15, 23, 42, 0.02)",
    border: "1px solid rgba(148, 163, 184, 0.2)",
  },
  groupLabel: {
    fontSize: "2.8px",
    fontWeight: 700,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.25em",
    marginBottom: "6px",
    paddingLeft: "2px",
    lineHeight: 1,
    transform: "scale(0.65)",
    transformOrigin: "left",
  },
  buttonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "6px",
    width: "100%",
  },
  button: {
    backgroundColor: "rgba(255,255,255,0.65)",
    color: "#0f172a",
    minWidth: "auto",
    width: "100%",
    minHeight: "34px",
    height: "auto",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "6px 8px",
    fontSize: "10.5px",
    fontWeight: 600,
    border: "1px solid rgba(148, 163, 184, 0.35)",
    textTransform: "none",
    transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
    gap: "6px",
    whiteSpace: "normal",
    overflow: "visible",
    textAlign: "left",
    lineHeight: 1.15,
    textOverflow: "ellipsis",
    "& .MuiButton-label": {
      width: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "&:hover": {
      backgroundColor: "rgba(59,130,246,0.08)",
      borderColor: "rgba(59,130,246,0.25)",
      boxShadow: "0 6px 16px rgba(15, 23, 42, 0.08)",
      transform: "translateY(-1px)",
    },
  },
  buttonFullWidth: {
    gridColumn: "1 / -1",
  },
  buttonIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "18px",
    height: "18px",
    flexShrink: 0,
  },
  saveButton: {
    backgroundColor: "#3b82f6",
    color: "#ffffff",
    borderRadius: "10px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.25)",
    border: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
    "&:hover": {
      backgroundColor: "#2563eb",
      transform: "translateY(-1px)",
      boxShadow: "0 6px 16px rgba(59, 130, 246, 0.35)",
    },
    "&:active": {
      transform: "translateY(0px)",
      boxShadow: "0 2px 8px rgba(59, 130, 246, 0.25)",
    },
  },
  backButton: {
    backgroundColor: "#f3f4f6",
    color: "#374151",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    border: "1px solid #e5e7eb",
    marginBottom: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#e5e7eb",
      borderColor: "#d1d5db",
    },
  },
  headerNotice: {
    backgroundColor: "#f0f9ff",
    border: "1px solid #bfdbfe",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "20px",
    color: "#1e40af",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
    position: "relative",
    zIndex: 10,
  },
  flowContainer: {
    width: "100%",
    height: "90%",
    position: "relative",
    display: "flex",
    borderRadius: "0 12px 12px 0",
    overflow: "hidden",
  },
  animatedEdge: {
    animation: "$dash 1.5s linear infinite",
  },
  "@keyframes dash": {
    from: {
      strokeDashoffset: 24,
    },
    to: {
      strokeDashoffset: 0,
    },
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    gap: "16px",
  },
  loadingText: {
    color: "#6b7280",
    fontSize: "16px",
    fontWeight: "500",
  },
}));

function geraStringAleatoria(tamanho) {
  var stringAleatoria = "";
  var caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < tamanho; i++) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

const GROUP_COLORS = [
  "#0ea5e9",
  "#f97316",
  "#22c55e",
  "#a855f7",
  "#ec4899",
  "#f59e0b",
  "#6366f1",
];

const NODE_TITLES = {
  message: "Mensagem",
  start: "Início do Fluxo",
  menu: "Menu",
  interval: "Intervalo",
  img: "Imagem",
  audio: "Áudio",
  randomizer: "Randomizador",
  video: "Vídeo",
  singleBlock: "Conteúdo",
  ticket: "Ticket",
  typebot: "Typebot",
  openai: "Agente IA",
  question: "Pergunta",
  file: "Arquivo",
  transferFlow: "Transferir Fluxo",
  apiRequest: "API Request",
  addTag: "Adicionar Tag",
  addTagKanban: "Tag Kanban",
  removeTag: "Remover Tag",
  removeTagKanban: "Remover Tag Kanban",
  condition: "Condição",
  keywordCondition: "Condição Múltipla",
  waitResponse: "Aguarda Resposta",
  templateMsg: "Modelo (Template)",
  smartInterval: "Intervalo Inteligente",
  metaPixel: "Pixel da Meta",
  pixPayment: "Pagamento Pix",
  igAction: "Instagram",
  igFollowCheck: "Verifica se segue",
  payLink: "Link ou Boleto",
  notify: "Notificação",
  aiBlock: "Inteligência Artificial",
  asaas: "2ª via Boleto",
  typebotNode: "Typebot",
  intervalNode: "Intervalo",
  smtp: "Envio SMTP",
  googleSheets: "Google Sheets",
  variable: "Variável",
  closeTicket: "Encerrar Ticket",
  sendMessage: "Enviar Mensagem",
  productList: "Lista de Produtos",
  waitQuestion: "Espera Condicional",
  sgpConsultaCliente: "SGP — Consultar Cliente",
  sgpSegundaVia: "SGP — 2ª Via",
  sgpAbrirChamado: "SGP — Abrir Chamado",
  sgpDesbloqueio: "SGP — Desbloqueio",
  sgpDiagnostico: "SGP — Diagnóstico de Conexão",
  scMenuPaciente: "Sys Clínica — Menu Paciente",
  scAgendamentos: "Sys Clínica — Agendamentos",
  scTreinos: "Sys Clínica — Treinos",
  scFaturas: "Sys Clínica — Faturas",
  infinityPay: "InfinityPay",
};

const DEFAULT_SMTP_CONFIG = {
  connectionName: "",
  fromEmail: "",
  host: "",
  port: "587",
  username: "",
  password: "",
  useTLS: true,
};

const DEFAULT_EMAIL_CONFIG = {
  to: "",
  replyTo: "",
  cc: "",
  bcc: "",
  subject: "",
  customContent: false,
  contentMode: "text",
  content: "",
  attachmentsVariable: "",
  saveVariables: [],
};

// ============================================================
// MODULOS OCULTOS NO CONSTRUTOR DE FLUXO
// Os blocos continuam existindo e os fluxos que ja usam seguem
// funcionando normalmente — eles apenas nao aparecem no menu.
// O super admin continua vendo todos (para testes).
// Para liberar um modulo aos clientes, basta REMOVER o nome desta lista.
// ============================================================
const MODULOS_OCULTOS = ["Sys Clínica", "SGP"];

const DEFAULT_VARIABLE_CONFIG = {
  variableName: "",
  valueType: "custom",
  editorMode: "text",
  customValue: "",
};

const getDefaultTitle = (type) => NODE_TITLES[type] || "Bloco";

const withTitleData = (type, data = {}) => {
  const nextTitle = data?.title || getDefaultTitle(type);
  return { ...data, title: nextTitle };
};

const ensureNodeTitle = (node) => ({
  ...node,
  data: withTitleData(node.type, node.data || {}),
});

const applyTitlesToNodes = (nodes = []) => nodes.map(ensureNodeTitle);

const nodeTypes = {
  message: withNodeTitle(messageNode, NODE_TITLES.message),
  start: withNodeTitle(startNode, NODE_TITLES.start),
  menu: withNodeTitle(menuNode, NODE_TITLES.menu),
  interval: withNodeTitle(intervalNode, NODE_TITLES.interval),
  img: withNodeTitle(imgNode, NODE_TITLES.img),
  audio: withNodeTitle(audioNode, NODE_TITLES.audio),
  randomizer: withNodeTitle(randomizerNode, NODE_TITLES.randomizer),
  video: withNodeTitle(videoNode, NODE_TITLES.video),
  singleBlock: withNodeTitle(singleBlockNode, NODE_TITLES.singleBlock),
  ticket: withNodeTitle(ticketNode, NODE_TITLES.ticket),
  typebot: withNodeTitle(typebotNode, NODE_TITLES.typebot),
  openai: withNodeTitle(openaiNode, NODE_TITLES.openai),
  directOpenai: withNodeTitle(directOpenaiNode, NODE_TITLES.openai),
  question: withNodeTitle(questionNode, NODE_TITLES.question),
  file: withNodeTitle(fileNode, NODE_TITLES.file),
  transferFlow: withNodeTitle(transferFlowNode, NODE_TITLES.transferFlow),
  apiRequest: withNodeTitle(apiRequestNode, NODE_TITLES.apiRequest),
  addTag: withNodeTitle(addTagNode, NODE_TITLES.addTag),
  addTagKanban: withNodeTitle(addTagKanbanNode, NODE_TITLES.addTagKanban),
  removeTag: withNodeTitle(removeTagNode, NODE_TITLES.removeTag),
  removeTagKanban: withNodeTitle(removeTagKanbanNode, NODE_TITLES.removeTagKanban),
  condition: withNodeTitle(conditionNode, NODE_TITLES.condition),
  keywordCondition: withNodeTitle(keywordConditionNode, NODE_TITLES.keywordCondition),
  waitResponse: withNodeTitle(waitResponseNode, NODE_TITLES.waitResponse),
  templateMsg: withNodeTitle(templateMsgNode, NODE_TITLES.templateMsg),
  smartInterval: withNodeTitle(smartIntervalNode, NODE_TITLES.smartInterval),
  metaPixel: withNodeTitle(metaPixelNode, NODE_TITLES.metaPixel),
  pixPayment: withNodeTitle(pixNode, NODE_TITLES.pixPayment),
  igAction: withNodeTitle(igActionNode, NODE_TITLES.igAction),
  igFollowCheck: withNodeTitle(igFollowCheckNode, NODE_TITLES.igFollowCheck),
  payLink: withNodeTitle(payLinkNode, NODE_TITLES.payLink),
  notify: withNodeTitle(notifyNode, NODE_TITLES.notify),
  aiBlock: withNodeTitle(aiBlockNode, NODE_TITLES.aiBlock),
  asaas: withNodeTitle(asaasNode, NODE_TITLES.asaas),
  smtp: withNodeTitle(smtpNode, NODE_TITLES.smtp),
  googleSheets: withNodeTitle(googleSheetsNode, NODE_TITLES.googleSheets),
  sendMessage: withNodeTitle(sendMessageNode, NODE_TITLES.sendMessage),
  productList: withNodeTitle(productListNode, NODE_TITLES.productList),
  waitQuestion: withNodeTitle(waitQuestionNode, NODE_TITLES.waitQuestion),
  closeTicket: withNodeTitle(closeTicketNode, NODE_TITLES.closeTicket),
  scheduleAppointment: scheduleAppointmentNode,
  listSchedules: listSchedulesNode,
  checkAvailability: checkAvailabilityNode,
  updateAppointment: updateAppointmentNode,
  cancelAppointment: cancelAppointmentNode,
  fetchLastAppointment: fetchLastAppointmentNode,
  smartAppointment: smartAppointmentNode,
  sgpConsultaCliente: withNodeTitle(sgpConsultaClienteNode, NODE_TITLES.sgpConsultaCliente),
  sgpSegundaVia: withNodeTitle(sgpSegundaViaNode, NODE_TITLES.sgpSegundaVia),
  sgpAbrirChamado: withNodeTitle(sgpAbrirChamadoNode, NODE_TITLES.sgpAbrirChamado),
  sgpDesbloqueio: withNodeTitle(sgpDesbloqueioNode, NODE_TITLES.sgpDesbloqueio),
  sgpDiagnostico: withNodeTitle(sgpDiagnosticoNode, NODE_TITLES.sgpDiagnostico),
  scMenuPaciente: withNodeTitle(scMenuPacienteNode, NODE_TITLES.scMenuPaciente),
  scAgendamentos: withNodeTitle(scAgendamentosNode, NODE_TITLES.scAgendamentos),
  scTreinos: withNodeTitle(scTreinosNode, NODE_TITLES.scTreinos),
  scFaturas: withNodeTitle(scFaturasNode, NODE_TITLES.scFaturas),
  infinityPay: withNodeTitle(infinityPayNode, NODE_TITLES.infinityPay),
};

const edgeTypes = {
  buttonedge: RemoveEdge,
};

const initialNodes = [
  {
    id: "1",
    position: { x: 250, y: 100 },
    data: withTitleData("start", { label: "Inicio do fluxo" }),
    type: "start",
  },
];

const initialEdges = [];

export const FlowBuilderConfig = () => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const { kanban } = usePlanPermissions();

  // Debug: verificar id
  console.log("FlowBuilderConfig - id do fluxo:", id);

  const storageItems = useNodeStorage();

  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [prompts, setPrompts] = useState([]);
  const [dataNode, setDataNode] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [modalAddText, setModalAddText] = useState(null);
  const [modalAddInterval, setModalAddInterval] = useState(false);
  const [modalAddMenu, setModalAddMenu] = useState(null);
  const [modalAddImg, setModalAddImg] = useState(null);
  const [modalAddAudio, setModalAddAudio] = useState(null);
  const [modalAddRandomizer, setModalAddRandomizer] = useState(null);
  const [modalAddVideo, setModalAddVideo] = useState(null);
  const [modalAddSingleBlock, setModalAddSingleBlock] = useState(null);
  const [contentModalType, setContentModalType] = useState(null);
  const [modalAddTicket, setModalAddTicket] = useState(null);
  const [modalAddTypebot, setModalAddTypebot] = useState(null);
  const [modalAddOpenAI, setModalAddOpenAI] = useState(null);
  const [modalAddDirectOpenAI, setModalAddDirectOpenAI] = useState(null);
  const [modalAddQuestion, setModalAddQuestion] = useState(null);
  const [modalAddFile, setModalAddFile] = useState(null);
  const [modalTransferFlow, setModalTransferFlow] = useState(null);
  const [modalApiRequest, setModalApiRequest] = useState(null);
  const [modalAddTag, setModalAddTag] = useState(null);
  const [modalAddTagKanban, setModalAddTagKanban] = useState(null);
  const [modalRemoveTag, setModalRemoveTag] = useState(null);
  const [modalRemoveTagKanban, setModalRemoveTagKanban] = useState(null);
  const [modalCondition, setModalCondition] = useState(null);
  const [modalKeywordCondition, setModalKeywordCondition] = useState(null);
  const [modalWaitResponse, setModalWaitResponse] = useState(null);
  const [modalTemplateMsg, setModalTemplateMsg] = useState(null);
  const [modalSmartInterval, setModalSmartInterval] = useState(null);
  const [modalMetaPixel, setModalMetaPixel] = useState(null);
  const [modalPix, setModalPix] = useState(null);
  const [modalIgAction, setModalIgAction] = useState(null);
  const [modalPayLink, setModalPayLink] = useState(null);
  const [modalNotify, setModalNotify] = useState(null);
  const [modalAiBlock, setModalAiBlock] = useState(null);
  const [modalAsaas, setModalAsaas] = useState(null);
  const [modalAddSmtp, setModalAddSmtp] = useState(null);
  const [modalAddGoogleSheets, setModalAddGoogleSheets] = useState(null);
  const [modalAddVariable, setModalAddVariable] = useState(null);
  const [modalCloseTicket, setModalCloseTicket] = useState(null);
  const [modalSendMessage, setModalSendMessage] = useState(null);
  const [modalProductList, setModalProductList] = useState(null);
  const [modalWaitQuestion, setModalWaitQuestion] = useState(null);
  const [modalScheduleAppointment, setModalScheduleAppointment] = useState(null);
  const [modalListSchedules, setModalListSchedules] = useState(null);
  const [modalCheckAvailability, setModalCheckAvailability] = useState(null);
  const [modalUpdateAppointment, setModalUpdateAppointment] = useState(null);
  const [modalCancelAppointment, setModalCancelAppointment] = useState(null);
  const [modalFetchLastAppointment, setModalFetchLastAppointment] = useState(null);
  const [modalSmartAppointment, setModalSmartAppointment] = useState(null);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [nodeRenaming, setNodeRenaming] = useState(null);
  const [modalSgpConsulta, setModalSgpConsulta] = useState(null);
  const [modalSgpSegundaVia, setModalSgpSegundaVia] = useState(null);
  const [modalSgpChamado, setModalSgpChamado] = useState(null);
  const [modalSgpDesbloqueio, setModalSgpDesbloqueio] = useState(null);
  const [modalSgpDiagnostico, setModalSgpDiagnostico] = useState(null);
  const [modalScMenuPaciente, setModalScMenuPaciente] = useState(null);
  const [modalScAgendamentos, setModalScAgendamentos] = useState(null);
  const [modalScTreinos, setModalScTreinos] = useState(null);
  const [modalScFaturas, setModalScFaturas] = useState(null);
  const [modalInfinityPay, setModalInfinityPay] = useState(null);
  const [flowLocked, setFlowLocked] = useState(false);
  const [, setPageNumber] = useState(1);

  const connectionLineStyle = { 
    stroke: "#6366f1", 
    strokeWidth: "3px",
    strokeDasharray: "5,5"
  };

  // [TODA A LÓGICA DE ADIÇÃO DE NODES MANTIDA IGUAL]
  const addNode = (type, data) => {
    const posY = nodes[nodes.length - 1].position.y;
    const posX =
      nodes[nodes.length - 1].position.x + nodes[nodes.length - 1].width + 40;

    if (type === "file") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("file", {
              label: data.label || "Enviar Arquivo",
              url: data.url,
            }),
            type: "file",
          },
        ];
      });
    }

    if (type === "start") {
      return setNodes((old) => {
        return [
          {
            id: "1",
            position: { x: posX, y: posY },
            data: withTitleData("start", { label: "Inicio do fluxo" }),
            type: "start",
          },
        ];
      });
    }
    if (type === "text") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("message", { label: data.text }),
            type: "message",
          },
        ];
      });
    }
    if (type === "interval") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("interval", {
              label: `Intervalo ${data.sec} seg.`,
              sec: data.sec,
            }),
            type: "interval",
          },
        ];
      });
    }
    if (type === "condition") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("condition", {
              key: data.key,
              condition: data.condition,
              value: data.value,
            }),
            type: "condition",
          },
        ];
      });
    }
    if (type === "waitResponse") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              message: data.message || "",
              answerKey: data.answerKey || "resposta",
              noAnswerMinutes: Number(data.noAnswerMinutes) || 0,
              bufferEnabled: !!data.bufferEnabled,
              bufferSeconds: Number(data.bufferSeconds) || 0,
              quoteEnabled: !!data.quoteEnabled,
              reactEnabled: !!data.reactEnabled,
              reactEmoji: data.reactEmoji || "✅",
            },
            type: "waitResponse",
          },
        ];
      });
    }
    if (type === "aiBlock") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              provider: data.provider || "openai",
              apiKey: data.apiKey || "",
              model: data.model || "gpt-4o-mini",
              systemPrompt: data.systemPrompt || "",
              userMessage: data.userMessage || "{{resposta}}",
              answerKey: data.answerKey || "ai.response",
              autoSend: !!data.autoSend,
              keepContext: !!data.keepContext,
              contextSize: Number(data.contextSize) || 5,
              entenderAudio: !!data.entenderAudio,
              entenderImagem: !!data.entenderImagem,
              entenderPdf: !!data.entenderPdf,
              identificarComprovante: !!data.identificarComprovante,
              smartConditions: Array.isArray(data.smartConditions) ? data.smartConditions : [],
              defaultOutput: data.defaultOutput || "padrao",
            },
            type: "aiBlock",
          },
        ];
      });
    }
    if (type === "notify") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: data.name || "Notificação",
              number: data.number || "",
              message: data.message || "",
            },
            type: "notify",
          },
        ];
      });
    }
    if (type === "payLink") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              tipo: data.tipo || "link",
              conteudo: data.conteudo || "",
              valor: data.valor || "",
              nomeRecebedor: data.nomeRecebedor || "",
              mensagem: data.mensagem || "",
            },
            type: "payLink",
          },
        ];
      });
    }
    if (type === "igAction") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: {
            acao: data.acao || "direct",
            texto: data.texto || "",
            botoes: data.botoes || [],
          },
          type: "igAction",
        },
      ]);
    }
    if (type === "igFollowCheck") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: {},
          type: "igFollowCheck",
        },
      ]);
    }
    if (type === "pixPayment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              origem: data.origem || "gerar",
              tipoChave: data.tipoChave || "telefone",
              formato: data.formato || "cartao",
              itemName: data.itemName || "",
              bodyText: data.bodyText || "",
              chave: data.chave || "",
              nomeRecebedor: data.nomeRecebedor || "",
              cidade: data.cidade || "",
              valor: data.valor || "",
              txid: data.txid || "",
              descricao: data.descricao || "",
              codigoVar: data.codigoVar || "",
              mensagem: data.mensagem || "",
              enviarQr: !!data.enviarQr,
              answerKey: data.answerKey || "pix.codigo",
            },
            type: "pixPayment",
          },
        ];
      });
    }
    if (type === "metaPixel") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              pixelKey: data.pixelKey || "",
              eventName: data.eventName || "Lead",
              value: data.value || "",
              currency: data.currency || "BRL",
              pageId: data.pageId || "",
            },
            type: "metaPixel",
          },
        ];
      });
    }
    if (type === "smartInterval") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              mode: data.mode || "interval",
              amount: Number(data.amount) || 0,
              unit: data.unit || "min",
              dateTime: data.dateTime || "",
              days: data.days || {},
            },
            type: "smartInterval",
          },
        ];
      });
    }
    if (type === "templateMsg") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              templateName: data.templateName || "",
              variables: data.variables || {},
            },
            type: "templateMsg",
          },
        ];
      });
    }
    if (type === "keywordCondition") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              keywords: data.keywords || [{ text: "", matchType: 2, color: "#10b981" }],
              caseSensitive: data.caseSensitive || false,
              ignoreAccents: data.ignoreAccents !== undefined ? data.ignoreAccents : true,
              waitAnyAnswer: !!data.waitAnyAnswer,
              noAnswerMinutes: Number(data.noAnswerMinutes) || 0,
            },
            type: "keywordCondition",
          },
        ];
      });
    }
    if (type === "menu") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("menu", {
              message: data.message,
              arrayOption: data.arrayOption,
            }),
            type: "menu",
          },
        ];
      });
    }
    if (type === "img") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("img", { url: data.url }),
            type: "img",
          },
        ];
      });
    }
    if (type === "audio") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("audio", { url: data.url, record: data.record }),
            type: "audio",
          },
        ];
      });
    }
    if (type === "randomizer") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("randomizer", { percent: data.percent }),
            type: "randomizer",
          },
        ];
      });
    }
    if (type === "video") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("video", { url: data.url }),
            type: "video",
          },
        ];
      });
    }
    if (type === "singleBlock") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("singleBlock", { ...data }),
            type: "singleBlock",
          },
        ];
      });
    }
    if (type === "ticket") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("ticket", { ...data }),
            type: "ticket",
          },
        ];
      });
    }
    if (type === "typebot") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("typebot", { ...data }),
            type: "typebot",
          },
        ];
      });
    }
    if (type === "openai") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("openai", { ...data }),
            type: "openai",
          },
        ];
      });
    }
    if (type === "question") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("question", { ...data }),
            type: "question",
          },
        ];
      });
    }
    if (type === "transferFlow") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("transferFlow", { ...data }),
            type: "transferFlow",
          },
        ];
      });
    }
    if (type === "apiRequest") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("apiRequest", { ...data }),
            type: "apiRequest",
          },
        ];
      });
    }
    if (type === "smtp") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("smtp", {
              smtpConfig: { ...DEFAULT_SMTP_CONFIG, ...(data?.smtpConfig || {}) },
              emailConfig: { ...DEFAULT_EMAIL_CONFIG, ...(data?.emailConfig || {}) },
            }),
            type: "smtp",
          },
        ];
      });
    }
    if (type === "addTag") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("addTag", { ...data }),
            type: "addTag",
          },
        ];
      });
    }
    if (type === "addTagKanban") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("addTagKanban", { ...data }),
            type: "addTagKanban",
          },
        ];
      });
    }
    if (type === "removeTag") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("removeTag", { ...data }),
            type: "removeTag",
          },
        ];
      });
    }
    if (type === "removeTagKanban") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("removeTagKanban", { ...data }),
            type: "removeTagKanban",
          },
        ];
      });
    }
    if (type === "scheduleAppointment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "scheduleAppointment",
          },
        ];
      });
    }
    if (type === "listSchedules") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "listSchedules",
          },
        ];
      });
    }
    if (type === "checkAvailability") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "checkAvailability",
          },
        ];
      });
    }
    if (type === "updateAppointment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "updateAppointment",
          },
        ];
      });
    }
    if (type === "cancelAppointment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "cancelAppointment",
          },
        ];
      });
    }
    if (type === "fetchLastAppointment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "fetchLastAppointment",
          },
        ];
      });
    }
    if (type === "smartAppointment") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "smartAppointment",
          },
        ];
      });
    }
    if (type === "asaas") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: withTitleData("asaas", { ...data }),
            type: "asaas",
          },
        ];
      });
    }
    if (type === "sgpConsultaCliente") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("sgpConsultaCliente", { ...data }),
        type: "sgpConsultaCliente",
      }]);
    }
    if (type === "sgpSegundaVia") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("sgpSegundaVia", { ...data }),
        type: "sgpSegundaVia",
      }]);
    }
    if (type === "sgpAbrirChamado") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("sgpAbrirChamado", { ...data }),
        type: "sgpAbrirChamado",
      }]);
    }
    if (type === "sgpDesbloqueio") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("sgpDesbloqueio", { ...data }),
        type: "sgpDesbloqueio",
      }]);
    }
    if (type === "sgpDiagnostico") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("sgpDiagnostico", { ...data }),
        type: "sgpDiagnostico",
      }]);
    }
    if (type === "scMenuPaciente") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("scMenuPaciente", { ...data }),
        type: "scMenuPaciente",
      }]);
    }
    if (type === "scAgendamentos") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("scAgendamentos", { ...data }),
        type: "scAgendamentos",
      }]);
    }
    if (type === "scTreinos") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("scTreinos", { ...data }),
        type: "scTreinos",
      }]);
    }
    if (type === "scFaturas") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("scFaturas", { ...data }),
        type: "scFaturas",
      }]);
    }
    if (type === "infinityPay") {
      return setNodes((old) => [...old, {
        id: geraStringAleatoria(30),
        position: { x: posX, y: posY },
        data: withTitleData("infinityPay", { ...data }),
        type: "infinityPay",
      }]);
    }
    if (type === "variable") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: withTitleData("variable", {
            variableConfig: {
              ...DEFAULT_VARIABLE_CONFIG,
              ...(data?.variableConfig || {}),
            },
          }),
          type: "variable",
        },
      ]);
    }
    if (type === "closeTicket") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: withTitleData("closeTicket", {
            message: data?.message || "",
          }),
          type: "closeTicket",
        },
      ]);
    }
    if (type === "sendMessage") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: withTitleData("sendMessage", { ...data }),
          type: "sendMessage",
        },
      ]);
    }
    if (type === "productList") {
      setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: withTitleData("productList", { 
            title: data?.title || "🛍️ Nossos Produtos e Serviços",
            listType: data?.listType || "all",
            displayType: data?.displayType || "standard",
            selectedItems: data?.selectedItems || []
          }),
          type: "productList",
        },
      ]);
      // Fechar modal após adicionar
      setModalProductList(null);
    }

    if (type === "waitQuestion") {
      setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: withTitleData("waitQuestion", {
            waitTime: data?.waitTime || 30,
            waitUnit: data?.waitUnit || "minutes",
            question: data?.question || "Você precisa de ajuda?",
            mediaType: data?.mediaType || "none",
            mediaUrl: data?.mediaUrl || null,
            mediaName: data?.mediaName || null,
            optionX: data?.optionX || {
              trigger: "1",
              matchType: "exact",
              label: "SIM",
              action: "continue"
            },
            optionY: data?.optionY || {
              trigger: "2",
              matchType: "exact",
              label: "NÃO",
              action: "transfer"
            },
            transferQueueId: data?.transferQueueId || null,
            closeTicket: data?.closeTicket || false,
            timeoutEnabled: data?.timeoutEnabled || false,
            timeoutTime: data?.timeoutTime || 60,
            timeoutUnit: data?.timeoutUnit || "minutes",
            timeoutAction: data?.timeoutAction || "continue"
          }),
          type: "waitQuestion",
        },
      ]);
      // Fechar modal após adicionar
      setModalWaitQuestion(null);
    }
  };

  // [TODAS AS FUNÇÕES DE ADIÇÃO MANTIDAS IGUAIS]
  const textAdd = (data) => { addNode("text", data); };
  const intervalAdd = (data) => { addNode("interval", data); };
  const conditionAdd = (data) => { addNode("condition", data); };
  const keywordConditionAdd = (data) => { addNode("keywordCondition", data); };
  const waitResponseAdd = (data) => { addNode("waitResponse", data); };
  const templateMsgAdd = (data) => { addNode("templateMsg", data); };
  const smartIntervalAdd = (data) => { addNode("smartInterval", data); };
  const metaPixelAdd = (data) => { addNode("metaPixel", data); };
  const pixAdd = (data) => { addNode("pixPayment", data); };
  const igActionAdd = (data) => { addNode("igAction", data); };
  const payLinkAdd = (data) => { addNode("payLink", data); };
  const notifyAdd = (data) => { addNode("notify", data); };
  const aiBlockAdd = (data) => { addNode("aiBlock", data); };
  const menuAdd = (data) => { addNode("menu", data); };
  const imgAdd = (data) => { addNode("img", data); };
  const audioAdd = (data) => { addNode("audio", data); };
  const randomizerAdd = (data) => { addNode("randomizer", data); };
  const waitQuestionAdd = (data) => { addNode("waitQuestion", data); };
  const videoAdd = (data) => { addNode("video", data); };
  const singleBlockAdd = (data) => { addNode("singleBlock", data); };
  const ticketAdd = (data) => { addNode("ticket", data); };
  const typebotAdd = (data) => { addNode("typebot", data); };
  const openaiAdd = (data) => { addNode("openai", data); };
  const questionAdd = (data) => { addNode("question", data); };
  const fileAdd = (data) => { addNode("file", data); };
  const transferFlowAdd = (data) => { addNode("transferFlow", data); };
  const apiRequestAdd = (data) => { addNode("apiRequest", data); };
  const addTagAdd = (data) => { addNode("addTag", data); };
  const addTagKanbanAdd = (data) => { addNode("addTagKanban", data); };
  const removeTagAdd = (data) => { addNode("removeTag", data); };
  const removeTagKanbanAdd = (data) => { addNode("removeTagKanban", data); };
  const asaasAdd = (data) => { addNode("asaas", data); };
  const sgpConsultaAdd = (data) => { addNode("sgpConsultaCliente", data); };
  const sgpSegundaViaAdd = (data) => { addNode("sgpSegundaVia", data); };
  const sgpChamadoAdd = (data) => { addNode("sgpAbrirChamado", data); };
  const sgpDesbloqueioAdd = (data) => { addNode("sgpDesbloqueio", data); };
  const sgpDiagnosticoAdd = (data) => { addNode("sgpDiagnostico", data); };
  const scMenuPacienteAdd = (data) => { addNode("scMenuPaciente", data); };
  const scAgendamentosAdd = (data) => { addNode("scAgendamentos", data); };
  const scTreinosAdd = (data) => { addNode("scTreinos", data); };
  const scFaturasAdd = (data) => { addNode("scFaturas", data); };
  const infinityPayAdd = (data) => { addNode("infinityPay", data); };
  const smtpAdd = (data) => { addNode("smtp", data); };
  const googleSheetsAdd = (data) => { addNode("googleSheets", data); };
  const variableAdd = (data) => { addNode("variable", data); };
  const closeTicketAdd = (data) => { addNode("closeTicket", data); };
  const sendMessageAdd = (data) => { addNode("sendMessage", data); };
  const productListAdd = (data) => { addNode("productList", data); };
  const scheduleAppointmentAdd = (data) => { addNode("scheduleAppointment", data); };
  const listSchedulesAdd = (data) => { addNode("listSchedules", data); };
  const checkAvailabilityAdd = (data) => { addNode("checkAvailability", data); };
  const updateAppointmentAdd = (data) => { addNode("updateAppointment", data); };
  const cancelAppointmentAdd = (data) => { addNode("cancelAppointment", data); };
  const fetchLastAppointmentAdd = (data) => { addNode("fetchLastAppointment", data); };
  const smartAppointmentAdd = (data) => { addNode("smartAppointment", data); };

  // [TODOS OS useEffect MANTIDOS IGUAIS]
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get(`/flowbuilder/flow/${id}`);

          if (data.flow.flow !== null) {
            const flowNodes = data.flow.flow.nodes;
            setNodes(applyTitlesToNodes(flowNodes));
            setEdges(enhanceEdges(data.flow.flow.connections || []));
            // Extrair variáveis dos nós question
            const questionNodes = flowNodes.filter(
              (nd) => nd.type === "question"
            );
            const questionVariables = questionNodes.map(
              (variable) => variable.data.typebotIntegration.answerKey
            );
            
            // Extrair variáveis dos nós apiRequest
            const apiNodes = flowNodes.filter(
              (nd) => nd.type === "apiRequest"
            );
            const apiVariables = apiNodes.flatMap(
              (node) => node.data?.data?.savedVariables?.map(variable => variable.name) || []
            );
            
            // Combinar todas as variáveis
            const allVariables = [...questionVariables, ...apiVariables];
            
            // Remover duplicatas e valores vazios
            const uniqueVariables = [...new Set(allVariables.filter(v => v && v.trim()))];
            
            localStorage.setItem("variables", JSON.stringify(uniqueVariables));
          }
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [id]);

  useEffect(() => {
    if (storageItems.action === "delete") {
      setNodes((old) => old.filter((item) => item.id !== storageItems.node));
      setEdges((old) => {
        const newData = old.filter((item) => item.source !== storageItems.node);
        const newClearTarget = newData.filter(
          (item) => item.target !== storageItems.node
        );
        return newClearTarget;
      });
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "duplicate") {
      const nodeDuplicate = nodes.filter(
        (item) => item.id === storageItems.node
      )[0];
      const maioresX = nodes.map((node) => node.position.x);
      const maiorX = Math.max(...maioresX);
      const finalY = nodes[nodes.length - 1].position.y;
      const nodeNew = {
        ...nodeDuplicate,
        id: geraStringAleatoria(30),
        position: {
          x: maiorX + 240,
          y: finalY,
        },
        selected: false,
        style: { backgroundColor: "#555555", padding: 0, borderRadius: 8 },
      };
      setNodes((old) => [...old, nodeNew]);
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "rename") {
      const nodeToRename = nodes.find((item) => item.id === storageItems.node);
      if (nodeToRename) {
        setNodeRenaming(nodeToRename);
        setRenameModalOpen(true);
      }
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
  }, [storageItems.action]);

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [groupSelectionActive, setGroupSelectionActive] = useState(false);
  const [groupSelectionIds, setGroupSelectionIds] = useState([]);
  const selectionActiveRef = useRef(false);
  const groupSelectionIdsRef = useRef([]);
  const groupColorIndexRef = useRef(0);

  const handleRemoveEdge = useCallback(
    (edgeId) => {
      setEdges((currentEdges) => currentEdges.filter((edge) => edge.id !== edgeId));
      toast.success("Conexão removida");
    },
    [setEdges]
  );

  const enhanceEdge = useCallback(
    (edge) => ({
      ...edge,
      type: "buttonedge",
      data: {
        ...(edge.data || {}),
        onRemove: () => handleRemoveEdge(edge.id),
      },
    }),
    [handleRemoveEdge]
  );

  const enhanceEdges = useCallback(
    (edgeList = []) => edgeList.map((edge) => enhanceEdge(edge)),
    [enhanceEdge]
  );

  const onConnect = useCallback(
    (params) =>
      setEdges((eds) => {
        const updated = addEdge({ ...params, type: "buttonedge" }, eds);
        return enhanceEdges(updated);
      }),
    [setEdges, enhanceEdges]
  );

  const handleEdgeDoubleClick = useCallback(
    (_event, edge) => {
      handleRemoveEdge(edge.id);
    },
    [handleRemoveEdge]
  );

  const pickGroupColor = useCallback(() => {
    const color = GROUP_COLORS[groupColorIndexRef.current % GROUP_COLORS.length];
    groupColorIndexRef.current += 1;
    return color;
  }, []);

  const clearGroupPreview = useCallback(() => {
    setNodes((old) =>
      old.map((node) =>
        node.data?.groupPreview
          ? {
            ...node,
            data: { ...node.data, groupPreview: false },
          }
          : node
      )
    );
  }, [setNodes]);

  const resetGroupSelection = useCallback(() => {
    groupSelectionIdsRef.current = [];
    setGroupSelectionIds([]);
    clearGroupPreview();
  }, [clearGroupPreview]);

  const stopGroupSelection = useCallback(() => {
    if (!selectionActiveRef.current) return;
    selectionActiveRef.current = false;
    setGroupSelectionActive(false);
    window.removeEventListener("mouseup", stopGroupSelection);
    const ids = groupSelectionIdsRef.current || [];
    if (ids.length > 0) {
      const rawTitle = window.prompt("Digite um título para este grupo:");
      const title = rawTitle ? rawTitle.trim() : "";
      if (title) {
        const color = pickGroupColor();
        setNodes((old) =>
          old.map((node) =>
            ids.includes(node.id)
              ? {
                ...node,
                data: {
                  ...node.data,
                  groupLabel: title,
                  groupColor: color,
                  groupPreview: false,
                },
              }
              : node
          )
        );
      }
    }
    resetGroupSelection();
  }, [pickGroupColor, resetGroupSelection, setNodes]);

  useEffect(() => {
    return () => {
      window.removeEventListener("mouseup", stopGroupSelection);
    };
  }, [stopGroupSelection]);

  const startGroupSelection = useCallback(() => {
    if (flowLocked) return;
    if (selectionActiveRef.current) return;
    selectionActiveRef.current = true;
    setGroupSelectionActive(true);
    groupSelectionIdsRef.current = [];
    setGroupSelectionIds([]);
    clearGroupPreview();
    window.addEventListener("mouseup", stopGroupSelection);
  }, [clearGroupPreview, flowLocked, stopGroupSelection]);

  const addNodeToSelection = useCallback(
    (nodeId) => {
      setGroupSelectionIds((prev) => {
        if (prev.includes(nodeId)) return prev;
        const updated = [...prev, nodeId];
        groupSelectionIdsRef.current = updated;
        setNodes((old) =>
          old.map((item) =>
            item.id === nodeId
              ? {
                ...item,
                data: { ...item.data, groupPreview: true },
              }
              : item
          )
        );
        return updated;
      });
    },
    [setNodes]
  );

  const handlePaneMouseDown = useCallback(
    (event) => {
      if (event.button === 2) {
        event.preventDefault();
        event.stopPropagation();
        startGroupSelection();
      }
    },
    [startGroupSelection]
  );

  const handleNodeMouseDown = useCallback(
    (event, node) => {
      if (event.button === 2) {
        event.preventDefault();
        event.stopPropagation();
        startGroupSelection();
        addNodeToSelection(node.id);
      }
    },
    [addNodeToSelection, startGroupSelection]
  );

  const handleNodeMouseEnter = useCallback(
    (event, node) => {
      if (!selectionActiveRef.current) return;
      event.preventDefault();
      addNodeToSelection(node.id);
    },
    [addNodeToSelection]
  );

  const saveFlow = async () => {
    const nodesWithTitles = applyTitlesToNodes(nodes);
    setNodes(nodesWithTitles);
    await api
      .post("/flowbuilder/flow", {
        idFlow: id,
        nodes: nodesWithTitles,
        connections: edges,
      })
      .then((res) => {
        toast.success("Fluxo salvo com sucesso");
      });
  };

  // [TODAS AS FUNÇÕES DE EVENTOS MANTIDAS IGUAIS]
  const doubleClick = (event, node) => {
    console.log("NODE", node);
    setDataNode(node);
    if (node.type === "message") { setModalAddText("edit"); }
    if (node.type === "interval") { setModalAddInterval("edit"); }
    if (node.type === "menu") { setModalAddMenu("edit"); }
    if (node.type === "img") { setModalAddImg("edit"); }
    if (node.type === "audio") { setModalAddAudio("edit"); }
    if (node.type === "randomizer") { setModalAddRandomizer("edit"); }
    if (node.type === "singleBlock") { setModalAddSingleBlock("edit"); }
    if (node.type === "ticket") { setModalAddTicket("edit"); }
    if (node.type === "typebot") { setModalAddTypebot("edit"); }
    if (node.type === "openai") { setModalAddOpenAI("edit"); }
    if (node.type === "directOpenai") { setModalAddDirectOpenAI("edit"); }
    if (node.type === "question") { setModalAddQuestion("edit"); }
    if (node.type === "file") { setModalAddFile("edit"); }
    if (node.type === "transferFlow") { setModalTransferFlow("edit"); }
    if (node.type === "apiRequest") { setModalApiRequest("edit"); }
    if (node.type === "addTag") { setModalAddTag("edit"); }
    if (node.type === "addTagKanban") { setModalAddTagKanban("edit"); }
    if (node.type === "removeTag") { setModalRemoveTag("edit"); }
    if (node.type === "removeTagKanban") { setModalRemoveTagKanban("edit"); }
    if (node.type === "condition") { setModalCondition("edit"); }
    if (node.type === "keywordCondition") { setModalKeywordCondition("edit"); }
    if (node.type === "waitResponse") { setModalWaitResponse("edit"); }
    if (node.type === "templateMsg") { setModalTemplateMsg("edit"); }
    if (node.type === "smartInterval") { setModalSmartInterval("edit"); }
    if (node.type === "metaPixel") { setModalMetaPixel("edit"); }
    if (node.type === "pixPayment") { setModalPix("edit"); }
    if (node.type === "igAction") { setModalIgAction("edit"); }
    if (node.type === "payLink") { setModalPayLink("edit"); }
    if (node.type === "notify") { setModalNotify("edit"); }
    if (node.type === "aiBlock") { setModalAiBlock("edit"); }
    if (node.type === "asaas") { setModalAsaas("edit"); }
    if (node.type === "sgpConsultaCliente") { setModalSgpConsulta("edit"); }
    if (node.type === "sgpSegundaVia") { setModalSgpSegundaVia("edit"); }
    if (node.type === "sgpAbrirChamado") { setModalSgpChamado("edit"); }
    if (node.type === "sgpDesbloqueio") { setModalSgpDesbloqueio("edit"); }
    if (node.type === "sgpDiagnostico") { setModalSgpDiagnostico("edit"); }
    if (node.type === "scMenuPaciente") { setModalScMenuPaciente("edit"); }
    if (node.type === "scAgendamentos") { setModalScAgendamentos("edit"); }
    if (node.type === "scTreinos") { setModalScTreinos("edit"); }
    if (node.type === "scFaturas") { setModalScFaturas("edit"); }
    if (node.type === "infinityPay") { setModalInfinityPay("edit"); }
    if (node.type === "smtp") { setModalAddSmtp("edit"); }
    if (node.type === "googleSheets") { setModalAddGoogleSheets("edit"); }
    if (node.type === "variable") { setModalAddVariable("edit"); }
    if (node.type === "closeTicket") { setModalCloseTicket("edit"); }
    if (node.type === "scheduleAppointment") { setModalScheduleAppointment("edit"); }
    if (node.type === "listSchedules") { setModalListSchedules("edit"); }
    if (node.type === "checkAvailability") { setModalCheckAvailability("edit"); }
    if (node.type === "updateAppointment") { setModalUpdateAppointment("edit"); }
    if (node.type === "cancelAppointment") { setModalCancelAppointment("edit"); }
    if (node.type === "fetchLastAppointment") { setModalFetchLastAppointment("edit"); }
    if (node.type === "smartAppointment") { setModalSmartAppointment("edit"); }
    if (node.type === "sendMessage") { setModalSendMessage("edit"); }
    if (node.type === "productList") { setModalProductList("edit"); }
    if (node.type === "waitQuestion") { setModalWaitQuestion("edit"); }
  };

  const clickNode = (event, node) => {
    setNodes((old) =>
      old.map((item) => {
        if (item.id === node.id) {
          return {
            ...item,
            style: { 
              backgroundColor: "#3b82f6", 
              padding: 1, 
              borderRadius: 8,
              pointerEvents: "auto" // Garante interatividade
            },
          };
        }
        return {
          ...item,
          style: { 
            backgroundColor: "#ffffff", 
            padding: 0, 
            borderRadius: 8,
            pointerEvents: "auto" // Garante interatividade
          },
        };
      })
    );
  };

  const clickEdge = (event, node) => {
    setNodes((old) =>
      old.map((item) => {
        return {
          ...item,
          style: { 
            backgroundColor: "#ffffff", 
            padding: 0, 
            borderRadius: 8,
            pointerEvents: "auto" // Garante interatividade
          },
        };
      })
    );
  };

  const updateNode = (dataAlter) => {
    setNodes((old) =>
      old.map((itemNode) => {
        if (itemNode.id === dataAlter.id) {
          return ensureNodeTitle(dataAlter);
        }
        return itemNode;
      })
    );
    setModalAddText(null);
    setModalAddInterval(null);
    setModalAddMenu(null);
    setModalAddOpenAI(null);
    setModalAddTypebot(null);
    setModalAddFile(null);
    setModalAddSmtp(null);
    setModalAddGoogleSheets(null);
    setModalAddVariable(null);
    setModalCloseTicket(null);
    setModalProductList(null);
    setModalWaitQuestion(null);
    setModalApiRequest(null);
  };

  const closeRenameModal = () => {
    setRenameModalOpen(false);
    setNodeRenaming(null);
  };

  const handleRenameSave = (newTitle) => {
    if (!nodeRenaming) {
      closeRenameModal();
      return;
    }
    const sanitizedTitle =
      (newTitle && newTitle.length ? newTitle : getDefaultTitle(nodeRenaming.type));
    setNodes((old) =>
      old.map((item) => {
        if (item.id === nodeRenaming.id) {
          return {
            ...item,
            data: {
              ...item.data,
              title: sanitizedTitle,
            },
          };
        }
        return item;
      })
    );
    closeRenameModal();
  };

  // Grupos reorganizados no estilo Typebot
  const actionGroups = [
    {
      label: "Bubbles",
      actions: [
        { icon: <Message sx={{ color: "#0ea5e9", fontSize: 14 }} />, name: "Conteúdo (misturar tudo)", type: "content" },
        { icon: <Message sx={{ color: "#3b82f6", fontSize: 14 }} />, name: "Texto", type: "content-text" },
        { icon: <Image sx={{ color: "#f59e0b", fontSize: 14 }} />, name: "Imagem", type: "content-image" },
        { icon: <Videocam sx={{ color: "#ef4444", fontSize: 14 }} />, name: "Vídeo", type: "content-video" },
        { icon: <MicNone sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Áudio", type: "content-audio" },
        { icon: <DescriptionIcon sx={{ color: "#6366f1", fontSize: 14 }} />, name: "Arquivo", type: "content-file" },
      ],
    },
    {
      label: "Inputs",
      actions: [
        { icon: <BallotIcon sx={{ color: "#f59e0b", fontSize: 14 }} />, name: "Pergunta", type: "question" },
        { icon: <DynamicFeed sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Menu", type: "menu" },
      ],
    },
    {
      label: "Lógica",
      actions: [
        { icon: <RocketLaunch sx={{ color: "#10b981", fontSize: 14 }} />, name: "Início", type: "start" },
        { icon: <AccessTime sx={{ color: "#22c55e", fontSize: 14 }} />, name: "Intervalo", type: "interval" },
        { icon: <CallSplit sx={{ color: "#06b6d4", fontSize: 14 }} />, name: "Randomizar", type: "random" },
        { icon: <AccountTree sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Transf. Fluxo", type: "transferFlow" },
        { icon: <ConfirmationNumber sx={{ color: "#ef4444", fontSize: 14 }} />, name: "Ticket", type: "ticket" },
        { icon: <Rule sx={{ color: "#3b82f6", fontSize: 14 }} />, name: "Condição Múltipla", type: "keywordCondition" },
        { icon: <Rule sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Condicional (campos)", type: "condition" },
        { icon: <Rule sx={{ color: "#f59e0b", fontSize: 14 }} />, name: "Aguarda Resposta", type: "waitResponse" },
        { icon: <DescriptionIcon sx={{ color: "#6366f1", fontSize: 14 }} />, name: "Modelo (Template)", type: "templateMsg" },
        { icon: <Rule sx={{ color: "#0ea5e9", fontSize: 14 }} />, name: "Intervalo Inteligente", type: "smartInterval" },
        { icon: <Rule sx={{ color: "#eab308", fontSize: 14 }} />, name: "Pixel da Meta", type: "metaPixel" },
        { icon: <Rule sx={{ color: "#22c55e", fontSize: 14 }} />, name: "Pagamento Pix", type: "pixPayment" },
        { icon: <Rule sx={{ color: "#ec4899", fontSize: 14 }} />, name: "Instagram: ação", type: "igAction" },
        { icon: <Rule sx={{ color: "#ec4899", fontSize: 14 }} />, name: "Instagram: verifica se segue", type: "igFollowCheck" },
        { icon: <Rule sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Link ou Boleto", type: "payLink" },
        { icon: <Rule sx={{ color: "#14b8a6", fontSize: 14 }} />, name: "Notificação", type: "notify" },
        { icon: <Rule sx={{ color: "#10b981", fontSize: 14 }} />, name: "IA (chave própria)", type: "aiBlock" },
      ],
    },
    {
      label: "Ações",
      actions: [
        { icon: <LocalOffer sx={{ color: "#f59e0b", fontSize: 14 }} />, name: "Add Tag", type: "addTag" },
        ...(kanban ? [{ icon: <ViewKanban sx={{ color: "#06b6d4", fontSize: 14 }} />, name: "Tag Kanban", type: "addTagKanban" }] : []),
        { icon: <LocalOffer sx={{ color: "#ef4444", fontSize: 14 }} />, name: "Remover Tag", type: "removeTag" },
        ...(kanban ? [{ icon: <ViewKanban sx={{ color: "#ef4444", fontSize: 14 }} />, name: "Remover Tag Kanban", type: "removeTagKanban" }] : []),
        { icon: <CheckCircle sx={{ color: "#22c55e", fontSize: 14 }} />, name: "Encerrar Ticket", type: "closeTicket" },
        { icon: <ShoppingBag sx={{ color: "#3b82f6", fontSize: 14 }} />, name: "Lista de Produtos", type: "productList" },
        { icon: <Schedule sx={{ color: "#fb923c", fontSize: 14 }} />, name: "Espera Condicional", type: "waitQuestion" },
      ],
    },
    {
      label: "Agendamento",
      actions: [
        { icon: <ListIcon sx={{ color: "#3b82f6", fontSize: 14 }} />, name: "Listar Agendas", type: "listSchedules" },
        { icon: <Search sx={{ color: "#06b6d4", fontSize: 14 }} />, name: "Buscar Último Agendamento", type: "fetchLastAppointment" },
        { icon: <Schedule sx={{ color: "#f59e0b", fontSize: 14 }} />, name: "Verificar Disponibilidade", type: "checkAvailability" },
        { icon: <EventIcon sx={{ color: "#10b981", fontSize: 14 }} />, name: "Agendar Compromisso", type: "scheduleAppointment" },
        { icon: <RocketLaunch sx={{ color: "#10b981", fontSize: 14 }} />, name: "Agendamento Inteligente", type: "smartAppointment" },
        { icon: <EditIcon sx={{ color: "#8b5cf6", fontSize: 14 }} />, name: "Atualizar Agendamento", type: "updateAppointment" },
        { icon: <CancelIcon sx={{ color: "#ef4444", fontSize: 14 }} />, name: "Cancelar Agendamento", type: "cancelAppointment" },
      ],
    },
    {
      label: "Integrações",
      actions: [
        { icon: <Http sx={{ color: "#22c55e", fontSize: 14 }} />, name: "API Request", type: "apiRequest" },
        { 
          icon: <Box component="img" sx={{ width: 14, height: 14 }} src={typebotIcon} alt="typebot" />, 
          name: "TypeBot", 
          type: "typebot" 
        },
        { icon: <Receipt sx={{ color: "#10b981", fontSize: 14 }} />, name: "2ª Via Boleto", type: "asaas" },
        { icon: <Email sx={{ color: "#2563eb", fontSize: 14 }} />, name: "Enviar SMTP", type: "smtp" },
        { icon: <Send sx={{ color: "#22c55e", fontSize: 14 }} />, name: "Enviar Mensagem", type: "sendMessage" },
        { icon: <span style={{ fontSize: "14px" }}>📊</span>, name: "Google Sheets", type: "googleSheets" },
        { icon: <MdSmartToy style={{ color: "#f97316", fontSize: 16 }} />, name: "Agente IA Direto", type: "directOpenai" },
      ],
    },
    {
      label: "Sys Clínica",
      actions: [
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#065f46" }}>🏥</span>, name: "Menu Paciente",   type: "scMenuPaciente" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0369a1" }}>📅</span>, name: "Agendamentos",   type: "scAgendamentos" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#7c3aed" }}>💪</span>, name: "Treinos",        type: "scTreinos" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#b45309" }}>💰</span>, name: "Faturas",        type: "scFaturas" },
      ],
    },
    {
      label: "SGP",
      actions: [
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0369a1" }}>🔍</span>, name: "Consultar Cliente", type: "sgpConsultaCliente" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0369a1" }}>🧾</span>, name: "2ª Via Faturas",    type: "sgpSegundaVia" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0369a1" }}>📋</span>, name: "Abrir Chamado",    type: "sgpAbrirChamado" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0369a1" }}>🔓</span>, name: "Desbloqueio",        type: "sgpDesbloqueio" },
        { icon: <span style={{ fontSize: 14, fontWeight: 700, color: "#0f766e" }}>📡</span>, name: "Diagnóstico Conexão", type: "sgpDiagnostico" },
      ],
    },
    {
      label: "InfinityPay",
      actions: [
        { icon: <span style={{ fontSize: 16, fontWeight: 900, color: "#6d28d9" }}>∞</span>, name: "Link de Pagamento", type: "infinityPay" },
      ],
    },
  ];

  const clickActions = (type) => {
    switch (type) {
      case "smtp":
        setModalAddSmtp("create");
        break;
      case "googleSheets":
        setModalAddGoogleSheets("create");
        break;
      case "variable":
        setModalAddVariable("create");
        break;
      case "closeTicket":
        setModalCloseTicket("create");
        break;
      case "start": addNode("start"); break;
      case "menu": setModalAddMenu("create"); break;
      case "content":
        setContentModalType(null); // permite todos os tipos
        setModalAddSingleBlock("create");
        break;
      case "content-text":
        setContentModalType("message");
        setModalAddSingleBlock("create");
        break;
      case "content-interval":
        setContentModalType("interval");
        setModalAddSingleBlock("create");
        break;
      case "content-image":
        setContentModalType("img");
        setModalAddSingleBlock("create");
        break;
      case "content-file":
        setContentModalType("file");
        setModalAddSingleBlock("create");
        break;
      case "content-audio":
        setContentModalType("audio");
        setModalAddSingleBlock("create");
        break;
      case "content-video":
        setContentModalType("video");
        setModalAddSingleBlock("create");
        break;
      case "random": setModalAddRandomizer("create"); break;
      case "interval": setModalAddInterval("create"); break;
      case "ticket": setModalAddTicket("create"); break;
      case "typebot": setModalAddTypebot("create"); break;
      case "openai": setModalAddOpenAI("create"); break;
      case "directOpenai": setModalAddDirectOpenAI("create"); break;
      case "question": setModalAddQuestion("create"); break;
      case "file": setModalAddFile("create"); break;
      case "transferFlow": setModalTransferFlow("create"); break;
      case "apiRequest": setModalApiRequest("create"); break;
      case "addTag": setModalAddTag("create"); break;
      case "addTagKanban": setModalAddTagKanban("create"); break;
      case "removeTag": setModalRemoveTag("create"); break;
      case "removeTagKanban": setModalRemoveTagKanban("create"); break;
      case "condition": setModalCondition("create"); break;
      case "keywordCondition": setModalKeywordCondition("create"); break;
      case "waitResponse": setModalWaitResponse("create"); break;
      case "templateMsg": setModalTemplateMsg("create"); break;
      case "smartInterval": setModalSmartInterval("create"); break;
      case "metaPixel": setModalMetaPixel("create"); break;
      case "pixPayment": setModalPix("create"); break;
      case "igAction": setModalIgAction("create"); break;
      case "igFollowCheck": addNode("igFollowCheck", {}); break;
      case "payLink": setModalPayLink("create"); break;
      case "notify": setModalNotify("create"); break;
      case "aiBlock": setModalAiBlock("create"); break;
      case "asaas": setModalAsaas("create"); break;
      case "sgpConsultaCliente": setModalSgpConsulta("create"); break;
      case "sgpSegundaVia": setModalSgpSegundaVia("create"); break;
      case "sgpAbrirChamado": setModalSgpChamado("create"); break;
      case "sgpDesbloqueio": setModalSgpDesbloqueio("create"); break;
      case "sgpDiagnostico": setModalSgpDiagnostico("create"); break;
      case "scMenuPaciente":  setModalScMenuPaciente("create");  break;
      case "scAgendamentos":  setModalScAgendamentos("create");  break;
      case "scTreinos":       setModalScTreinos("create");       break;
      case "scFaturas":       setModalScFaturas("create");       break;
      case "infinityPay": setModalInfinityPay("create"); break;
      case "sendMessage": setModalSendMessage("create"); break;
      case "productList": setModalProductList("create"); break;
      case "waitQuestion": setModalWaitQuestion("create"); break;
      case "scheduleAppointment": setModalScheduleAppointment("create"); break;
      case "listSchedules": setModalListSchedules("create"); break;
      case "checkAvailability": setModalCheckAvailability("create"); break;
      case "updateAppointment": setModalUpdateAppointment("create"); break;
      case "cancelAppointment": setModalCancelAppointment("create"); break;
      case "fetchLastAppointment": setModalFetchLastAppointment("create"); break;
      case "smartAppointment": setModalSmartAppointment("create"); break;
      default: break;
    }
  };

  return (
    <Stack sx={{ height: "100vh", backgroundColor: "#f9fafb" }}>
      {/* TODOS OS MODAIS MANTIDOS IGUAIS */}
      <FlowBuilderAddTextModal
        open={modalAddText}
        onSave={textAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddText(null)}
      />
      <FlowBuilderIntervalModal
        open={modalAddInterval}
        onSave={intervalAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddInterval(null)}
      />
      <FlowBuilderMenuModal
        open={modalAddMenu}
        onSave={menuAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddMenu(null)}
      />
      <FlowBuilderAddImgModal
        open={modalAddImg}
        onSave={imgAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddImg(null)}
      />
      <FlowBuilderAddAudioModal
        open={modalAddAudio}
        onSave={audioAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddAudio(null)}
      />
      <FlowBuilderRandomizerModal
        open={modalAddRandomizer}
        onSave={randomizerAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddRandomizer(null)}
      />
      <FlowBuilderAddVideoModal
        open={modalAddVideo}
        onSave={videoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddVideo(null)}
      />
      <FlowBuilderSingleBlockModal
        open={modalAddSingleBlock}
        onSave={singleBlockAdd}
        data={dataNode}
        onUpdate={updateNode}
        contentType={contentModalType}
        close={() => setModalAddSingleBlock(null)}
      />
      <FlowBuilderTicketModal
        open={modalAddTicket}
        onSave={ticketAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTicket(null)}
      />
      <FlowBuilderOpenAIModal
        open={modalAddOpenAI}
        onSave={openaiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddOpenAI(null)}
      />
      <FlowBuilderTypebotModal
        open={modalAddTypebot}
        onSave={typebotAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTypebot(null)}
      />
      <FlowBuilderAddQuestionModal
        open={modalAddQuestion}
        onSave={questionAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddQuestion(null)}
      />
      <FlowBuilderAddFileModal
        open={modalAddFile}
        onSave={fileAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddFile(null)}
      />
      <FlowBuilderTransferFlowModal
        open={modalTransferFlow}
        onSave={transferFlowAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalTransferFlow(null)}
      />
      <FlowBuilderApiRequestModal
        open={modalApiRequest}
        onSave={apiRequestAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalApiRequest(null)}
      />
      <FlowBuilderAddTagModal
        open={modalAddTag}
        onSave={addTagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTag(null)}
      />
      <FlowBuilderAddTagKanbanModal
        open={modalAddTagKanban}
        onSave={addTagKanbanAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTagKanban(null)}
      />
      <FlowBuilderRemoveTagModal
        open={modalRemoveTag}
        onSave={removeTagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalRemoveTag(null)}
      />
      <FlowBuilderRemoveTagKanbanModal
        open={modalRemoveTagKanban}
        onSave={removeTagKanbanAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalRemoveTagKanban(null)}
      />
      <FlowBuilderConditionModal
        open={modalCondition}
        onSave={conditionAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalCondition(null)}
      flowNodes={nodes}
      />
      <FlowBuilderAiBlockModal
        open={modalAiBlock}
        onSave={aiBlockAdd}
        data={dataNode}
        onUpdate={updateNode}
        flowNodes={nodes}
        close={() => setModalAiBlock(null)}
      />
      <FlowBuilderNotifyModal
        open={modalNotify}
        onSave={notifyAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalNotify(null)}
      />
      <FlowBuilderMetaPixelModal
        open={modalMetaPixel}
        onSave={metaPixelAdd}
        data={dataNode}
        onUpdate={updateNode}
        flowNodes={nodes}
        close={() => setModalMetaPixel(null)}
      />
      <FlowBuilderPixModal
        open={modalPix}
        onSave={pixAdd}
        data={dataNode}
        onUpdate={updateNode}
        flowNodes={nodes}
        close={() => setModalPix(null)}
      />
      <FlowBuilderIgActionModal
        open={modalIgAction}
        onSave={igActionAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalIgAction(null)}
      />
      <FlowBuilderPayLinkModal
        open={modalPayLink}
        onSave={payLinkAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalPayLink(null)}
      />
      <FlowBuilderSmartIntervalModal
        open={modalSmartInterval}
        onSave={smartIntervalAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSmartInterval(null)}
      />
      <FlowBuilderTemplateModal
        open={modalTemplateMsg}
        onSave={templateMsgAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalTemplateMsg(null)}
      />
      <FlowBuilderWaitResponseModal
        open={modalWaitResponse}
        onSave={waitResponseAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalWaitResponse(null)}
      />
      <FlowBuilderKeywordConditionModal
        open={modalKeywordCondition}
        onSave={keywordConditionAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalKeywordCondition(null)}
      />
      <FlowBuilderAsaasModal
        open={modalAsaas}
        onSave={asaasAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAsaas(null)}
      />
      <FlowBuilderAddSmtpModal
        open={modalAddSmtp}
        onSave={smtpAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddSmtp(null)}
      />
      <FlowBuilderGoogleSheetsModal
        open={modalAddGoogleSheets}
        onSave={googleSheetsAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddGoogleSheets(null)}
      />
      <FlowBuilderAddVariableModal
        open={modalAddVariable}
        onSave={variableAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddVariable(null)}
      />
      <FlowBuilderCloseTicketModal
        open={modalCloseTicket}
        onSave={closeTicketAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalCloseTicket(null)}
      />
      <FlowBuilderSendMessageModal
        open={modalSendMessage}
        onSave={sendMessageAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSendMessage(null)}
      />
      <FlowBuilderProductListModal
        open={modalProductList}
        onSave={productListAdd}
        data={dataNode}
        onUpdate={updateNode}
        onClose={() => setModalProductList(null)}
      />
      <FlowBuilderWaitQuestionModal
        open={modalWaitQuestion}
        onSave={waitQuestionAdd}
        initialValue={dataNode}
        onUpdate={updateNode}
        onClose={() => setModalWaitQuestion(null)}
      />
      <FlowBuilderScheduleAppointmentModal
        open={!!modalScheduleAppointment}
        onSave={scheduleAppointmentAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalScheduleAppointment(null)}
      />
      <FlowBuilderListSchedulesModal
        open={!!modalListSchedules}
        onSave={listSchedulesAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalListSchedules(null)}
      />
      <FlowBuilderCheckAvailabilityModal
        open={!!modalCheckAvailability}
        onSave={checkAvailabilityAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalCheckAvailability(null)}
      />
      <FlowBuilderUpdateAppointmentModal
        open={!!modalUpdateAppointment}
        onSave={updateAppointmentAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalUpdateAppointment(null)}
      />
      <FlowBuilderCancelAppointmentModal
        open={!!modalCancelAppointment}
        onSave={cancelAppointmentAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalCancelAppointment(null)}
      />
      <FlowBuilderFetchLastAppointmentModal
        open={!!modalFetchLastAppointment}
        onSave={fetchLastAppointmentAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalFetchLastAppointment(null)}
      />
      <FlowBuilderScMenuPacienteModal
        open={modalScMenuPaciente}
        onSave={scMenuPacienteAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalScMenuPaciente(null)}
      />
      <FlowBuilderScAgendamentosModal
        open={modalScAgendamentos}
        onSave={scAgendamentosAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalScAgendamentos(null)}
      />
      <FlowBuilderScTreinosModal
        open={modalScTreinos}
        onSave={scTreinosAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalScTreinos(null)}
      />
      <FlowBuilderScFaturasModal
        open={modalScFaturas}
        onSave={scFaturasAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalScFaturas(null)}
      />
      <FlowBuilderSgpConsultaModal
        open={modalSgpConsulta}
        onSave={sgpConsultaAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSgpConsulta(null)}
      />
      <FlowBuilderSgpSegundaViaModal
        open={modalSgpSegundaVia}
        onSave={sgpSegundaViaAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSgpSegundaVia(null)}
      />
      <FlowBuilderSgpChamadoModal
        open={modalSgpChamado}
        onSave={sgpChamadoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSgpChamado(null)}
      />
      <FlowBuilderSgpDesbloqueioModal
        open={modalSgpDesbloqueio}
        onSave={sgpDesbloqueioAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSgpDesbloqueio(null)}
      />
      <FlowBuilderSgpDiagnosticoModal
        open={modalSgpDiagnostico}
        onSave={sgpDiagnosticoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalSgpDiagnostico(null)}
      />
      <FlowBuilderInfinityPayModal
        open={modalInfinityPay}
        onSave={infinityPayAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalInfinityPay(null)}
      />
      <FlowBuilderSmartAppointmentModal
        open={!!modalSmartAppointment}
        onSave={smartAppointmentAdd}
        initialData={dataNode?.data}
        onUpdate={updateNode}
        onClose={() => setModalSmartAppointment(null)}
      />
      <FlowBuilderNodeRenameModal
        open={renameModalOpen}
        node={nodeRenaming}
        defaultTitle={nodeRenaming ? getDefaultTitle(nodeRenaming.type) : "Bloco"}
        onClose={closeRenameModal}
        onSave={handleRenameSave}
      />

      {!loading && (
        <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
          {/* Sidebar Estilo Typebot */}
          <Stack className={classes.sidebar}>
            {/* Back Button */}
            <Button
              className={classes.backButton}
              startIcon={<ArrowBackIcon />}
              onClick={() => history.push("/fluxos")}
            >
              Voltar
            </Button>
            
            {actionGroups
              .filter((group) => user?.super || !MODULOS_OCULTOS.includes(group.label))
              .map((group) => (
              <div key={group.label} className={classes.buttonGroup}>
                <Typography className={classes.groupLabel}>
                  {group.label}
                </Typography>
                <div className={classes.buttonGrid}>
                  {group.actions.map((action) => (
                    <Button
                      key={action.name}
                      className={classes.button}
                      onClick={() => clickActions(action.type)}
                    >
                      <Box className={classes.buttonIcon} sx={{ flexShrink: 0 }}>
                        {action.icon}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          fontSize: "11.5px",
                          lineHeight: 1.15,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {action.name}
                      </Typography>
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </Stack>

          {/* Save Button - Fixed bottom right */}
          <Button
            color="primary"
            variant="contained"
            className={classes.saveButton}
            startIcon={<SaveIcon />}
            onClick={() => saveFlow()}
          >
            Salvar Fluxo
          </Button>

          
          {/* Flow Container */}
          <Stack className={classes.flowContainer} sx={{ paddingLeft: "260px" }}>
            <ReactFlow
              nodes={nodes}
              edges={edges}
              deleteKeyCode={["Backspace", "Delete"]}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onNodeDoubleClick={doubleClick}
              onNodeClick={clickNode}
              onEdgeClick={clickEdge}
              onPaneMouseDown={handlePaneMouseDown}
              onNodeMouseDown={handleNodeMouseDown}
              onNodeMouseEnter={handleNodeMouseEnter}
              onPaneContextMenu={(event) => event.preventDefault()}
              onNodeContextMenu={(event) => event.preventDefault()}
              onConnect={onConnect}
              nodeTypes={nodeTypes}
              edgeTypes={edgeTypes}
              fitView
              connectionLineStyle={connectionLineStyle}
              style={{
                backgroundColor: "#fafbfc",
              }}
              defaultEdgeOptions={{
                style: { 
                  stroke: "#6366f1", 
                  strokeWidth: "3px"
                },
                animated: true,
                className: classes.animatedEdge,
              }}
              nodesDraggable={!flowLocked}
              nodesConnectable={!flowLocked}
              elementsSelectable={!flowLocked}
              selectNodesOnDrag={false}
              panOnDrag={true}
              zoomOnScroll={true}
              zoomOnDoubleClick={false}
              onlyRenderVisibleElements={false}
            >
              <Controls 
                showZoom={true}
                showFitView={true}
                showInteractive={true}
                position="bottom-left"
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
              >
                              </Controls>
              <Background 
                variant="dots" 
                gap={16} 
                size={1.5} 
                color="#d4d4d8"
                style={{ backgroundColor: "#fafafa" }}
              />
            </ReactFlow>
          </Stack>
        </Paper>
      )}

      {loading && (
        <Stack className={classes.loadingContainer}>
          <CircularProgress size={48} style={{ color: "#3b82f6" }} />
          <Typography className={classes.loadingText}>
            Carregando construtor de fluxo...
          </Typography>
        </Stack>
      )}
      
      <FlowBuilderAddDirectOpenAIModal
        open={modalAddDirectOpenAI}
        data={dataNode}
        close={() => setModalAddDirectOpenAI(null)}
        onSave={(config) => {
          if (modalAddDirectOpenAI === "edit") {
            // Update existing node
            setNodes((nds) =>
              nds.map((node) => {
                if (node.id === dataNode.id) {
                  return {
                    ...node,
                    data: {
                      ...node.data,
                      ...config
                    }
                  };
                }
                return node;
              })
            );
          } else {
            // Add new node
            const newNode = {
              id: `directOpenai-${Date.now()}`,
              type: "directOpenai",
              position: { x: 100, y: 100 },
              data: config
            };
            setNodes((nds) => [...nds, newNode]);
          }
          setModalAddDirectOpenAI(null);
        }}
      />
    </Stack>
  );
};